import * as React from 'react';

import CourseraEmailPreferencesList from 'bundles/account-settings/components/sections/email-preferences/CourseraEmailPreferencesList';
import { useIsRemindersPreferenceVisible } from 'bundles/account-settings/components/sections/email-preferences/hooks/useIsRemindersPreferenceVisible';
import type {
  CourseraNormalizedEmailPreference,
  GlobalNotificationPreferences,
  UpdateStatus,
} from 'bundles/account-settings/types/EmailPreferences';

import _t from 'i18n!nls/account-settings';

type Props = {
  preferences: GlobalNotificationPreferences;
  updateStatus: UpdateStatus;
  disabled: boolean;
};

const preparePreferences = (preferences: GlobalNotificationPreferences): CourseraNormalizedEmailPreference[] => [
  {
    id: 'recommendations',
    name: _t('Weekly personalized course recommendations'),
    value: { recommendations: preferences.recommendations },
  },
  {
    id: 'promotions',
    name: _t('Weekly notifications about promotions, new courses and programs, and special events'),
    value: { promotions: preferences.promotions },
  },
  {
    id: 'degrees',
    name: _t('Information on online Master’s and Bachelor’s Degree programs'),
    value: { degrees: preferences.degrees },
  },
  {
    id: 'volunteer',
    name: _t(`Surveys and invitations to help us improve Coursera content and your experience`),
    value: { volunteer: preferences.volunteer },
  },
  {
    id: 'reminders',
    name: _t('Notifications for course authors about your content'),
    value: { reminders: preferences.reminders },
  },
];

const CourseraEmailPreferences = ({ preferences, updateStatus, disabled }: Props) => {
  const isRemindersPreferenceVisible = useIsRemindersPreferenceVisible();

  const initialPreferences = React.useMemo(() => {
    const allPreferences = preparePreferences(preferences);
    return isRemindersPreferenceVisible
      ? allPreferences
      : allPreferences.filter((preference) => preference.id !== 'reminders');
  }, [preferences, isRemindersPreferenceVisible]);

  return (
    <CourseraEmailPreferencesList
      disabled={disabled}
      emailPreferences={initialPreferences}
      updateStatus={updateStatus}
    />
  );
};

export default CourseraEmailPreferences;
